import React, { FC } from 'react';
import Icon from 'src/common/components/IconDS22';
import { EXTERNAL_PATHS } from 'src/common/constants';
import Button from 'src/common/components/Button';
import useMediaQuery, { sharedMediaQueries } from 'src/common/hooks/useMediaQuery';
import s from './Connect.module.scss';

const Connect: FC = () => {
  const isDesktop = useMediaQuery(sharedMediaQueries.m);

  return (
    <div className={s.panel}>
      <Button
        href={EXTERNAL_PATHS.GOOGLE_OAUTH_CALENDAR}
        classNameModifier="noMargin"
        fullWidth={!isDesktop}
      >
        Connect Google Calendar
        <Icon id="link" />
      </Button>
      We’ll redirect you to Google to authenticate your account. We only request access to
      manage your calendar events related to your boats.
    </div>
  );
};

export default Connect;
